import { useEffect } from 'react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { Button } from '@workspace/ui/components/button'
import { Card, CardContent } from '@workspace/ui/components/card'
import { ArrowLeft, Printer } from 'lucide-react'
import { FormRenderer } from '@/features/forms/renderer/form-renderer'

export const Route = createFileRoute(
  '/_authenticated/_organization/forms/$formId/preview'
)({
  component: FormPreviewPage,
})

function FormPreviewPage() {
  const { formId } = useParams({ strict: false }) as { formId: string }
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  return (
    <div className='fixed inset-0 z-50 overflow-y-auto bg-[#0a2540] print:static print:overflow-visible print:bg-white'>
      <div className='sticky top-0 z-10 flex items-center justify-between px-4 py-3 print:hidden'>
        <div className='flex items-center gap-2'>
          <Button
            variant='ghost'
            size='sm'
            className='text-white hover:bg-white/10'
            onClick={() => navigate({ to: '/forms' })}
          >
            <ArrowLeft className='mr-2 h-4 w-4' />
            Exit Preview
          </Button>
          <Button
            variant='ghost'
            size='sm'
            className='text-white hover:bg-white/10'
            onClick={() => window.print()}
          >
            <Printer className='mr-2 h-4 w-4' />
            Print
          </Button>
        </div>
        <span className='rounded-md bg-white/10 px-3 py-1.5 text-sm font-medium text-white'>
          Preview Mode
        </span>
      </div>
      <div className='mx-auto max-w-3xl px-4 pb-16 print:px-0 print:py-0'>
        <Card className='shadow-2xl print:border-0 print:shadow-none'>
          <CardContent className='p-6 sm:p-8 print:p-0'>
            <FormRenderer
              formId={formId}
              organizationId={activeOrganization.id}
              mode='preview'
              onSuccess={() => {
                navigate({
                  to: '/forms',
                })
              }}
              onCancel={() => {
                navigate({
                  to: '/forms',
                })
              }}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
